// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"6383cb82","747":"cbd671fa","888":"c0c2bf68"}[chunkId] + ".chunk.js";
};